<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>
      &copy; {{ new Date().getFullYear() }}
      <a href="https://www.bistpay.com" target="_blank" rel="nofollow"
        >بیست پی - راهکار نوین دریافت</a
      >
    </span>
    <span class="md:flex hidden items-center">
      <span>
        <a href="https://www.bistpay.com" target="_blank"  :title="title"
          >v-{{ this.$version.name }}</a
        >
      </span>
      <!-- <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
    </span>

    <!-- buyNow component -->
    <!-- <component :is="injections.components.BuyNow"></component> -->
  </footer>
</template>

<script>
// import BuyNow from '../../components/BuyNow.vue'

export default {
  name: "the-footer",
  data() {
    return {
    };
  },
  computed: {
    title(){
      return `شماره ورژن: ${this.$version.number}
تاریخ انتشار: ${this.$version.date}`
    }
  },
  props: {
    classes: {
      type: String,
    },
  },
  inject: {
    components: {
      default: {},
    },
  },
  mounted() {
    this.$http
      .get(
        "/api/services/app/AppVersions/GetApp?input=5b0a5dd7-68e8-4830-b548-d7ba0ec45ec6"
      )
      .then((response) => {
        this.version = response.data.result.version;
        this.name = response.data.result.name;
        const forceLoginToken = response.data.result.forceLoginToken;
        if (!localStorage.getItem("forceLoginToken") && forceLoginToken) {
          localStorage.setItem("forceLoginToken", forceLoginToken);
        } else if (localStorage.getItem("forceLoginToken") != forceLoginToken) {
          localStorage.setItem("forceLoginToken", forceLoginToken);

          this.$store.dispatch("auth/Logout");
          this.$router.push("/pages/login");
        }
      }) //end success
      .catch((error) => {
        console.log(error);
        this.$vs.loading.close();
      }); //end http
  },
};
</script>
